module.exports = __webpack_public_path__ + "img/spdb.01b59f39.png";